export enum PageRoutes {
  // Static pages
  home = '/',
  contactUs = '/contact-us',

  // Bathing date pages
  maghMela = '/magh-mela-2026',
  whoWeAre = '/magh-mela-2026/who-we-are',
  paushPurnima = '/magh-mela-2026/paush-purnima',
  makarSankranti = '/magh-mela-2026/makar-sankranti',
  mauniAmavasya = '/magh-mela-2026/mauni-amavasya',
  basantPanchami = '/magh-mela-2026/basant-panchami',
  maghiPurnima = '/magh-mela-2026/maghi-purnima',
  mahaShivratri = '/magh-mela-2026/maha-shivratri',

  // Package detail pages
  packages = '/accommodations',
  mudhouse = '/accommodations/traditional-mudhouse',
  mudhouseDormitory = '/accommodations/mudhouse-dormitory',
  premiumTwinTent = '/accommodations/premium-twin-tent',

  // Tour packages
  mahakumbhPackage = '/packages/mahakumbh',
  varanasiPackage = '/packages/varanasi',
  ayodhyaPackage = '/packages/ayodhya',

  // Reservation
  reservation = '/reservation',
}
